import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ConfirmationService } from 'primeng/api';
import { Crop } from 'src/app/models/crop';
import { PreCodePreferences } from 'src/app/models/preCodePreferences';
import { ApiService } from 'src/app/services/api.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { StaticFields } from 'src/app/shared/staticFields';
import { GeassessmentmodalComponent } from '../geassessmentmodal/geassessmentmodal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserPreferredGeTrait } from 'src/app/models/userPreferredGeTrait';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { ResetService } from 'src/app/services/reset.service';
import { MultiSelectComponent } from 'src/app/shared/multiSelectComponent';
import { AutoCompleteComponent } from 'src/app/shared/autoComplete';
import { Reset } from 'src/app/models/reset';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrl: './preferences.component.scss'
})
export class PreferencesComponent {
  stageDict: any = {};
  selectedCrop: any;
  levels: any[] = [{name: 'Program(s)'},{name: 'Region(s)'},{name: 'EZ(s)'}];
  selectedLevel: any;
  inclusions: any[];
  selectedInclusions: any[] = [];
  stages: string[] = [];
  selectedStages: any[] = [];
  years: string[] = StaticFields.years;
  selectedYears: any[] = [];
  geLineageChecked: boolean = false;
  seedInventoryChecked: boolean = false;
  popRequestChecked: boolean = false;
  experimentsChecked: boolean = false;
  regions: any[] = [];
  ezs: any = [];
  programs: any = [];
  programsCopy: any = [];
  geAssessmentsList: UserPreferredGeTrait[] = [];
  selectedAssessments: any[] = [];
  precodePreference : PreCodePreferences = new PreCodePreferences();
  settingPageLoadData: boolean = false;
  colorOptions: any[] = [
    {type: "GE", color : "#C0E6F5" },
    {type: "SI", color : "#F1A983" },
    {type: "POP", color : "#C1F0C8" },
    {type: "EXPT", color : "#7ff0d7" },
    {type: "APEX", color : "#FFFFCC" },
    {type: "TRAIT", color : "#f7d3a1" }
];
  ref: DynamicDialogRef | undefined;
  gePreference: any[] = [];
  pStageChecked: boolean = false;
  // genToFetch: any = {name:"0", val: 0};
  // genList: any = [{name:"All", val: -100},{name:"5", val: 5},{name:"4", val: 4},{name:"3", val: 3},{name:"2", val: 2},{name:"1", val: 1},{name:"0", val: 0},{name:"-1", val: -1},{name:"-2", val: -2},{name:"-3", val: -3},{name:"-4", val: -4},{name:"-5", val: -5}];
  selectedPStages: any[] = [];
  pStagesList: any[] = [];
  showPStageModal: boolean = false;
  pStageData: any[] = [];
  pStageDataCopy: any;
  pStageGridApi: any;
  tagGridApi: any;
  selectedPStageCrop: any;
  pStageRegions: any;
  pStageEzs: any;
  pStagePrograms: any;
  pStageCounter: number = 0;
  favouritePrograms: any[] = [];
  showSelFavorites: boolean = false;
  cropReset: boolean;
  apexVoteChecked : boolean = false;
  public components: {
      [p: string]: any;
    } = {
      customMultiSelectEditor: MultiSelectComponent,
      customAutoComplete: AutoCompleteComponent
    };
  pStageColDef: ColDef[] = [
    // { field: 'crop', headerName: 'Crop',cellEditor: 'agSelectCellEditor', editable: true, onCellValueChanged(event) {
    //   if (event.data.crop !== event.context.componentParent.selectedCrop.Name) {
    //     event.context.componentParent.changeCrop(true,event.data.crop);
    //   }
    // },
    //   cellEditorParams: () => { return { values: this.crops.map((ele:any) => ele.Name), valueListMaxHeight: 250 } } },
    { field: 'settingType', headerName: 'Type', cellEditor: 'agSelectCellEditor', editable: true,
      cellEditorParams: () => { return { values: ["PStage","Vote"], valueListMaxHeight: 100 } }},
    { field: 'type', headerName: 'Level', cellEditor: 'agSelectCellEditor', editable: true,
      cellEditorParams: (params: any) => { return { values: params.data.settingType === "PStage" && !(StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0) ? ["Program(s)","Region(s)","EZ(s)"] : ["Program(s)"], valueListMaxHeight: 100 } }},
    { field: 'name', headerName: 'Name', cellEditor: 'customMultiSelectEditor' , editable: true,
      suppressKeyboardEvent: params => {
        const key = params.event.key;
        const gridShouldDoNothing = params.editing && (key === "Enter" );
        return gridShouldDoNothing;
      }
    },
    { field: 'year',headerName : 'Year',  cellEditor: 'customMultiSelectEditor', editable: true,
      suppressKeyboardEvent: params => {
        const key = params.event.key;
        const gridShouldDoNothing = params.editing && (key === "Enter" );
        return gridShouldDoNothing;
      },
      cellEditorParams : (params : any )=> {
        return {values:StaticFields.years, dataSourceType: "years"}
      } 
    }
  ];
  defaultPStageColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: { buttons: ["clear"] },
    minWidth : 50,
    resizable: true,
    editable: false
  };
  gridOptionsPStage : GridOptions = {
    context: {
      componentParent: this,
    },
    singleClickEdit: true
  }
  gridOptionsTag : GridOptions = {
    context: {
      componentParent: this,
    },
    singleClickEdit: true,
    rowDragManaged: true,
    getContextMenuItems: this.getTagContextMenuItems,
    onRowDragEnd : p => {
      this.tags.splice(0);
      this.tagGridApi!.forEachNode((n: any) => this.tags.push(n.data));
    }
  }
  tagColDef: ColDef[] = [
    { rowDrag: true, suppressHeaderFilterButton: true, suppressHeaderMenuButton: true, resizable: false, minWidth: 40, width: 40, pinned: 'left', sortable: false },
    { suppressHeaderFilterButton: true, suppressHeaderMenuButton: true, resizable: false, minWidth: 40, width: 40, checkboxSelection: true, headerCheckboxSelection : true, headerCheckboxSelectionFilteredOnly: true, pinned: 'left' },
    { field: 'tag', headerName: 'Tag', editable: true , width: 200,
      valueSetter: params => {
        if (this.tags.filter((t: any) => t.tag.toUpperCase() === params.newValue.toUpperCase()).length < 1) {
          params.data.tag = params.newValue;
          return true;
        } else
          return false;
      } 
    },
    { field: 'group', headerName: 'Group', editable: true,  cellEditor: 'customAutoComplete',
      cellEditorParams : (params : any )=> {
        return {tagGroups: this.tagGroups, group: params.value}
      } 
    },
    { field: 'isActive', headerName: 'Is Active',cellRenderer: 'agCheckboxCellRenderer', editable: true, width: 110 }
  ];
  prevCrop: any = {};
  showProgramColorModel: boolean = false;
  selPrgRgnEZ: any;
  prgRgnEZColor: any;
  existingPrgRgnEZColors: any = [];
  prgRgnEZColors: any = [];
  selPrgRgnEZColors: any = [];
  prgRgnEZNames: any = [];
  types: any[] = [{name: 'Program'},{name: 'Region'},{name: 'EZ'}];
  selType: any;
  tag: string = "";
  tags: any = [];
  wrapHeader: boolean = false;
  flyoutType: string = 'none'
  tagsInUse: string[] = [];
  tagToMerge: string = "";
  mergeOverlayVisible: boolean;
  showTagModal: boolean = false;
  showInactiveTags: boolean = false;

  constructor(public customMessageService: CustomMessageService, private apiService : ApiService, private confirmationService: ConfirmationService, public dialogService: DialogService, private resetService : ResetService) { 
    this.resetService.resetData$.subscribe((reset: Reset) => {
      if (reset) {
       if (ResetService.Crops == reset.Type){
          this.cropReset = true;
          this.resetPreferences();
        }
        if (ResetService.Programs == reset.Type){
          this.getProgramPreference();
        }
        if (ResetService.EvaluationZones == reset.Type){
          this.getEvaluationZonePreference();          
        }
      }
    });
  }
  get tagGroups(): any {
    if (this.tags && this.tags.length > 0) {
      return [...new Set(this.tags.filter((t: any) => t.group).map((t: any) => t.group))].sort();
    }
    return [];
  }
  get allowReset() : boolean {
    if(StaticFields.precodePreference?.appUserId && this.selectedCrop && this.selectedLevel){
      const preSelectedAssessments = StaticFields.precodePreference.userPreferredGeTraits ? StaticFields.precodePreference.userPreferredGeTraits.map(({ traitId, traitName,traitDescription,selected }) => ({ traitId, traitName,traitDescription,selected })) : [];
      const selectedAssessments = this.geAssessmentsList.map(({ traitId, traitName,traitDescription,selected }) => ({ traitId, traitName,traitDescription,selected }));
      const preSelectedPStages = StaticFields.precodePreference.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages.map(({  crop,type,name,year,selected }) => ({  crop,type,name,year,selected })) : [];
      const selectedPStages= this.pStagesList.map(({  crop,type,name,year,selected }) => ({  crop,type,name,year,selected }));
      selectedPStages.forEach(ele => {
        this.selectedPStages.forEach(e => {
          if(ele.crop == e.crop && ele.type == e.type && ele.name == e.name && ele.year == e.year)
            ele['selected'] = true;
        })
      });
      return this.selectedCrop.Name !== StaticFields.precodePreference.crop || this.selectedLevel.name !== StaticFields.precodePreference.level || 
      ((StaticFields.precodePreference.include !== "" || this.selectedInclusions.join(",") !== "") && JSON.stringify(this.selectedInclusions.map(i => i.code).sort((a,b) => a-b)) !== JSON.stringify(StaticFields.precodePreference.include.split(",").sort((a: any,b: any) => a-b))) ||
      ((StaticFields.precodePreference.stage !== "" || this.selectedStages.join(",") !== "") && JSON.stringify(this.selectedStages.sort((a,b) => a-b)) !== JSON.stringify(StaticFields.precodePreference.stage.split(",").sort((a: any,b: any) => a-b))) ||
      ((StaticFields.precodePreference.years !== "" || this.selectedYears.join(",") !== "") && JSON.stringify(this.selectedYears.sort((a,b) => a-b)) !== JSON.stringify(StaticFields.precodePreference.years.split(",").sort((a: any,b: any) => a-b))) ||
      ((StaticFields.precodePreference.favouritePrograms !== "" || this.favouritePrograms.join(",") !== "") && JSON.stringify(this.favouritePrograms.map(p => p.code).sort((a,b) => a-b)) !== JSON.stringify(StaticFields.precodePreference.favouritePrograms.split(",").sort((a: any,b: any) => a-b))) ||
      this.geLineageChecked !== StaticFields.precodePreference.geLineage || this.popRequestChecked !== StaticFields.precodePreference.popRequest ||
      this.seedInventoryChecked !== StaticFields.precodePreference.seedInventory || this.experimentsChecked !== StaticFields.precodePreference.experiments || this.apexVoteChecked !== StaticFields.precodePreference.apexVote || this.wrapHeader !== StaticFields.precodePreference.wrapHeader 
      || this.flyoutType !== StaticFields.precodePreference.flyoutType || JSON.stringify([...this.colorOptions, ...this.existingPrgRgnEZColors]) != StaticFields.precodePreference.headerColorOptions ||
      ((StaticFields.precodePreference.userPreferredGeTraits.length > 0 || this.geAssessmentsList.length > 0 ) && JSON.stringify(preSelectedAssessments) !== JSON.stringify(selectedAssessments)) ||
      ((StaticFields.precodePreference.userPreferredPStages.length > 0 || this.pStageData.length > 0 ) && JSON.stringify(preSelectedPStages) !== JSON.stringify(selectedPStages)) ||
      ((StaticFields.precodePreference.tags || this.tags.length > 0 ) && JSON.stringify(StaticFields.precodePreference.tags) !== JSON.stringify(this.tags.map((t: any) => `${t.tag}:${t.isActive}:${t.group}`).join(';')));
    } else {
      return this.selectedCrop ? true : false;
    }
  }

  get crops(): Crop [] {
    return StaticFields?.crops && StaticFields?.crops?.length > 0 ? StaticFields?.crops?.filter(ele => ele.isActive) : [];
  }

  get validPstageData() : number {
    let count = 0;
    this.pStageData.forEach(ele => {
      if(ele.type !== "" && (ele.name.length > 0 && ele.year.length > 0)) {
        count++;
      }
    })
    return count;
  }

  get allowPStageSettingSave() : boolean {
    return JSON.stringify(this.pStageData) === JSON.stringify(this.pStageDataCopy);
  }

  get allowTagSave() : boolean {
    if (!StaticFields.precodePreference)
      return true;
    const tags = this.tags.map((t: any) => `${t.tag}:${t.isActive}:${t.group}`).join(';');
    return StaticFields.precodePreference.tags !== tags;
  }

  get mergeOptions(): any[] {
    return this.tagGridApi && this.tagGridApi.getSelectedRows().length === 1 ? this.tags.filter((t: any) => this.tagGridApi.getSelectedRows()[0].tag !== t.tag).map((t: any) => t.tag) : [];
  }

  ngOnInit(): void {
    this.apiService.getData('GetTagsInUse', null, false).subscribe((result : any) => {
      this.tagsInUse = result;
    });
    if (StaticFields.appUserId)
      this.setScreenData();  
    else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId) {
          this.setScreenData();
          clearInterval(interval);
        }
      }, 2000);
    }
    const elements = document.getElementsByClassName("footer-container");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = 'none';
    }
  }

  setScreenData() {
    if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId) {
      this.selectedCrop = this.crops.find(ele => ele.Name == StaticFields.precodePreference.crop);
      if (this.selectedCrop) {
        this.changeCrop(false,this.selectedCrop.Name);        
        this.selectedLevel = this.levels.find(ele => ele.name == StaticFields.precodePreference.level);
        this.changeLevel();
        this.selectedYears = StaticFields.precodePreference.years !== "" && StaticFields.precodePreference.years.split(",").length > 0 ? StaticFields.precodePreference.years.split(",") : [] ;
        this.geLineageChecked = StaticFields.precodePreference.geLineage;
        this.popRequestChecked = StaticFields.precodePreference.popRequest;
        this.seedInventoryChecked = StaticFields.precodePreference.seedInventory;
        this.experimentsChecked = StaticFields.precodePreference.experiments;
        this.apexVoteChecked = StaticFields.precodePreference.apexVote;
        this.wrapHeader = StaticFields.precodePreference.wrapHeader;
        this.flyoutType = StaticFields.precodePreference.flyoutType ? StaticFields.precodePreference.flyoutType : 'none';
        this.geAssessmentsList = JSON.parse(JSON.stringify(StaticFields.precodePreference.userPreferredGeTraits));
        if (StaticFields.precodePreference?.headerColorOptions) {
          const savedColorPref = JSON.parse(StaticFields.precodePreference.headerColorOptions);
          this.existingPrgRgnEZColors = savedColorPref.filter((cp: any) => cp.isProgram);
          this.colorOptions = savedColorPref.filter((cp: any) => !cp.isProgram);
        }
        this.selectedAssessments = this.geAssessmentsList.filter(ele => ele.selected == true);
        this.pStagesList = JSON.parse(JSON.stringify(StaticFields.precodePreference?.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages : [] )); 
        this.pStageData =  JSON.parse(JSON.stringify(StaticFields.precodePreference?.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages : [] ));   
        this.pStageData.forEach(ele => {ele.name = ele.name.split(",");ele.year = ele.year.split(",")});
        this.selectedPStages = this.pStagesList.filter(ele => ele.selected == true);
        this.tags.splice(0);
        if (StaticFields.precodePreference.tags) {
          StaticFields.precodePreference.tags.split(";").forEach((t: any) => {
            const tagParts = t.split(':');
            let group = '';
            if (tagParts.length === 3) {
              group = tagParts[2];
            }
            this.tags.push({tag: tagParts[0], isActive: tagParts[1] === 'true', group: group});
          });
        }
      } else {
        this.customMessageService.showMessage({severity: 'warn', summary:`Crop ${StaticFields.precodePreference.crop} is inactive` , detail: `Saved crop ${StaticFields.precodePreference.crop} is inactive, can't load preferences.`});
      }      
    }
  }

  changeCrop(isPStage? : boolean, crop? : string) {
    if(this.prevCrop != null) {
      if(StaticFields.precodePreference  && StaticFields.precodePreference?.crop && StaticFields.precodePreference?.crop !== this.selectedCrop?.Name && !isPStage) {
        this.confirmationService.confirm({
          header: 'Confirmation',
          icon: 'pi pi-exclamatison-triangle',
          message: `Changes made will be lost if the crop was changed without saving?`,     
          accept: () => {
            this.geAssessmentsList= [];
            this.pStageData = [];
            this.selectedAssessments = [];
            this.selectedPStages = [];
            this.selectedStages = [];
            this.selectedYears = [];
            this.favouritePrograms = [];
            this.selectedInclusions = [];
            this.inclusions = [];
            this.stages = [];

            this.selectedLevel = null;        

            this.prevCrop = JSON.parse(JSON.stringify(this.selectedCrop));
            this.pStagesList = []
            this.programsCopy = this.favouritePrograms   = [];
            //this.genToFetch = {name:"0", val: 0};
            this.geLineageChecked = this.popRequestChecked = this.experimentsChecked = this.seedInventoryChecked = this.apexVoteChecked = false;       
            this.getMasterData();
          },
          reject: () => {
            this.selectedCrop = this.crops.find(ele => ele.Name == StaticFields.precodePreference.crop);
          }
        });
      } else {
        this.getMasterData(isPStage,crop);
      }
    }
    else
      this.getMasterData(isPStage,crop);
  }

  changeLevel() {
    const interval = setInterval(() => {
      if (this.programs && this.programs.length > 0) {
        clearInterval(interval);
        if (this.selectedLevel?.name === "Program(s)") {
          this.inclusions = this.programs.map((d: any) => { return {code: d.code, desc: d.description};});
        } else if (this.selectedLevel?.name === "Region(s)") {
          this.inclusions = this.regions.map((d: any) => { return {code: d.Code, desc: d.Description};});
        } else if (this.selectedLevel?.name === "EZ(s)") {
          this.inclusions = this.ezs.map((d: any) => { return {code: d.code, desc: d.description};});
        } else if (this.inclusions){
          this.inclusions.splice(0);
        }
        if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId && StaticFields.precodePreference.crop == this.selectedCrop?.Name) {
          if (this.inclusions && this.inclusions.length > 0) {
            const inclPredicate = StaticFields.precodePreference.include.split(",").some(ele => this.inclusions.findIndex((i: any) => i.code === ele) > -1);
            const selInclusions = inclPredicate && StaticFields.precodePreference.include!= "" &&  StaticFields.precodePreference.include.split(",").length > 0 ?  StaticFields.precodePreference.include.split(",").filter(ele => this.inclusions.findIndex((i: any) => i.code === ele) > -1) : [];
            this.selectedInclusions = this.inclusions.filter(i => selInclusions.includes(i.code));
          }
          if (this.stages && this.stages.length > 0) {
            const stagePredicate = StaticFields.precodePreference.stage.split(",").some(ele => this.stages.includes(ele));
            this.selectedStages = stagePredicate && StaticFields.precodePreference.stage != "" && StaticFields.precodePreference.stage.split(",").length > 0 ? StaticFields.precodePreference.stage.split(",").filter(ele => this.stages.indexOf(ele) > -1) : [];
          }
          if (this.favouritePrograms && this.favouritePrograms.length > 0) {
            this.favouritePrograms = [...StaticFields.precodePreference.favouritePrograms.split(",")];
            this.favouritePrograms = this.programs.filter((ele : any) => this.favouritePrograms.indexOf(ele.code) !== -1);
          }
        }
      }
    }, 100);
  }

  getRegionsPrograms(isPStage ?:  boolean, crop? : string) {
    this.getProgramPreference(isPStage);
    this.getEvaluationZonePreference(isPStage);
    let params = new HttpParams();
    const cropId = isPStage ? this.crops.find(ele => ele.Name === crop).Id : this.selectedCrop?.Id;
    params = params.append('cropId', cropId);
    if (StaticFields.precodePreference && StaticFields.precodePreference?.crop === this.selectedCrop?.Name) {
      this.geAssessmentsList = [...StaticFields.precodePreference.userPreferredGeTraits];
      this.pStagesList = JSON.parse(JSON.stringify(StaticFields.precodePreference?.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages : [] )); 
      this.pStageData =  JSON.parse(JSON.stringify(StaticFields.precodePreference?.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages : [] ));   
      this.pStageData.forEach(ele => {ele.name = ele.name.split(",");ele.year = ele.year.split(",")});
    }
    if (cropId) {
      this.apiService.getRADData(`Regions?$filter=CropId eq ${this.selectedCrop.Id} and Status/Name eq 'Active'&$select=Id,Code,Description`).subscribe((result : any) => {
        if (result.value.findIndex((v: any) => v.Code.toUpperCase() === 'WW') === -1)
          result.value.push({Code: 'WW', Description: 'Worldwide'});
        result.value = result.value.sort((a: any , b: any) => a.Code.localeCompare(b.Code));   
        if(!isPStage) {
          this.regions = result.value;
          if (this.selectedLevel && this.selectedLevel.name === "Region(s)")
            this.changeLevel();
          } else {
            this.pStageRegions = result.value;
          }     
      });
      // this.apiService.getRADData(`EvaluationZones?$filter=CropId eq ${this.selectedCrop.Id} and Status/Name eq 'Active'&$select=Id,Code,Description`).subscribe((result : any) => {
      //   result.value = result.value.sort((a: any , b: any) => a.Code.localeCompare(b.Code));  
      //   if(!isPStage) {
      //       this.ezs = result.value;
      //       if (this.selectedLevel && this.selectedLevel.name === "EZ(s)")
      //         this.changeLevel();
      //     }
      //     else {
      //       this.pStageEzs = result.value;
      //     } 
      // });
      
    }    
  }

  getEvaluationZonePreference(isPStage: boolean = false) {   
    this.apiService.getOData(`EvaluationZonePreferences?$filter=CropName eq '${this.selectedCrop.Name}' and IsActive&$select=Id,Code,Description`).subscribe((result : any) => {  
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      if(!isPStage) {
          this.ezs = result.value;
          if (this.selectedLevel && this.selectedLevel.name === "EZ(s)")
            this.changeLevel();
        }
        else {
          this.pStageEzs = result.value;
       } 
    });
  }

  getProgramPreference(isPStage: boolean = false){
    // this.apiService.getRADData(`Programs?$filter=CropId eq ${this.selectedCrop.Id} and Status/Name eq 'Active'&$select=Id,Code,Description`).subscribe((result : any) => {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${this.selectedCrop.Name}'and IsActive&$select=Id,Code,Description${selectCountry}`).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code));  
      if (!isPStage) {
        this.programs = result.value;
        this.programsCopy = JSON.parse(JSON.stringify(this.programs));
        if (this.selectedLevel && this.selectedLevel.name === "Program(s)")
          this.changeLevel();
      }
      else {
        this.pStagePrograms = result.value;
      }   
    });
  }

  getMasterData(isPStage? : boolean, crop? : string) {
    if(!isPStage) {
      this.stageDict = {};
      this.stages.splice(0);
      StaticFields.masterData?.filter(p => p.type == 'Stage' && p.crop ==this.selectedCrop?.Name && p.isActive).forEach((s: any) => {   
        if (s.stage && !(s.stage in this.stageDict)){      
          this.stageDict[s.stage.toUpperCase()] = [];
          this.stageDict[s.stage.toUpperCase()].push(s.stage);
          this.stages.push(s.stage);
        }
        // if (s.nextStage) {
        //     this.stageDict[s.stage.toUpperCase()].push(s.nextStage);
        //     const foundNextStage = StaticFields.masterData?.find((d: any) => d.stage.toUpperCase() === s.nextStage.toUpperCase())
        //     if (foundNextStage && foundNextStage.nextStage)
        //         this.stageDict[s.stage.toUpperCase()].push(foundNextStage.nextStage);
        // }
          
      }); 
      this.stages = [...this.stages]
    }
    this.getRegionsPrograms(isPStage,crop);      
  }
  
  getExpandOptions() {
    const expandBy: string[] = [];
    if (this.geLineageChecked)
      expandBy.push('GE');
    if (this.seedInventoryChecked)
      expandBy.push('SI');
    if (this.popRequestChecked)
      expandBy.push('POP');
    if (this.experimentsChecked)
      expandBy.push('EXPT');
    if (this.apexVoteChecked)
      expandBy.push('APEX');
    return expandBy.join();
  }

  onRowClick(event : any) {
    event["selected"] = !event["selected"];
  }

  changeFavoritesView($event: CheckboxChangeEvent) {
    this.programsCopy = $event.checked ? JSON.parse(JSON.stringify(this.favouritePrograms)) : JSON.parse(JSON.stringify(this.programs));
  }

  resetPreferences() {
    if(!this.cropReset) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: `Are you sure you want to reset the screen?`,     
        accept: () => {
          if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId ) {
            this.setScreenData();
          } else {
            this.selectedCrop = null;
            this.selectedLevel = this.selectedInclusions = this.selectedStages = this.selectedYears = this.selectedAssessments = this.selectedPStages = this.pStagesList = this.geAssessmentsList =  [];
            this.favouritePrograms = [];
            this.programsCopy = [];
            //this.genToFetch = {name:"0", val: 0};
            this.geLineageChecked = this.popRequestChecked = this.experimentsChecked = this.seedInventoryChecked = this.apexVoteChecked = this.wrapHeader = false;
            this.flyoutType = 'none';
            this.tags.splice(0);
          }
        }
      });
    } else {
      this.selectedCrop = null;
      this.selectedLevel = this.selectedInclusions = this.selectedStages = this.selectedYears = [];
      this.favouritePrograms = this.programsCopy = [];
      //this.genToFetch = {name:"0", val: 0};
      this.geLineageChecked = this.popRequestChecked = this.experimentsChecked = this.seedInventoryChecked  = this.apexVoteChecked = this.wrapHeader = false;
      this.flyoutType = 'none';
      this.cropReset = false;
      this.tags.splice(0);
      // StaticFields.precodePreference.crop = "";
      // StaticFields.precodePreference.level = "";
      // StaticFields.precodePreference.include = "";
      // StaticFields.precodePreference.stage =   '';
      // StaticFields.precodePreference.favouritePrograms =  '';
      // StaticFields.precodePreference.years = '';
      // StaticFields.precodePreference.geLineage = false;
      // StaticFields.precodePreference.popRequest = false;
      // StaticFields.precodePreference.seedInventory = false;
      // StaticFields.precodePreference.experiments = false;
      // StaticFields.precodePreference.apexVote = false;
      // StaticFields.precodePreference.userPreferredGeTraits = [];   
      // StaticFields.precodePreference.userPreferredPStages = [];
      // this.savePreferences(true)
    }
    
  }

  savePreferences(resetCrop? : boolean) {
    if (!StaticFields.precodePreference)
      StaticFields.precodePreference = new PreCodePreferences();
    if (!StaticFields.precodePreference.appUserId) {
      StaticFields.precodePreference.appUserId = StaticFields.appUserId;
    }
    if (!resetCrop) {
      StaticFields.precodePreference.type = 'PreCode';
      StaticFields.precodePreference.crop = this.selectedCrop?.Name;
      StaticFields.precodePreference.level = this.selectedLevel ? this.selectedLevel.name : '';
      StaticFields.precodePreference.include = this.selectedInclusions.map(i => i.code).join();
      StaticFields.precodePreference.stage =  this.selectedStages ? this.selectedStages.join() : '';
      StaticFields.precodePreference.favouritePrograms =  this.favouritePrograms ? this.favouritePrograms.map(ele => ele.code).join() : '';
      StaticFields.precodePreference.years =  this.selectedYears ? this.selectedYears.join() : '';
      StaticFields.precodePreference.geLineage = this.geLineageChecked;
      StaticFields.precodePreference.popRequest = this.popRequestChecked;
      StaticFields.precodePreference.seedInventory = this.seedInventoryChecked;
      StaticFields.precodePreference.experiments = this.experimentsChecked;
      StaticFields.precodePreference.apexVote = this.apexVoteChecked;
      StaticFields.precodePreference.wrapHeader = this.wrapHeader;
      StaticFields.precodePreference.flyoutType = this.flyoutType;
      StaticFields.precodePreference.tags = this.tags.map((t: any) => `${t.tag}:${t.isActive}:${t.group}`).join(';');
      const headerLegend = [...this.colorOptions, ...this.existingPrgRgnEZColors];
      if (StaticFields.precodeScreenData)
        StaticFields.precodeScreenData.headerLegend = headerLegend
      StaticFields.precodePreference.headerColorOptions = JSON.stringify(headerLegend);
      const cropId = this.crops.find(ele => ele.Name === this.selectedCrop.Name).Id;
      this.geAssessmentsList.forEach(ele => { ele.cropId = cropId; ele.aois = ele.years = null; });
      StaticFields.precodePreference.userPreferredGeTraits = this.geAssessmentsList;   
      this.pStagesList.forEach(ele => delete ele.id);
      StaticFields.precodePreference.userPreferredPStages = this.pStagesList;
    }
    const pref = JSON.parse(JSON.stringify(StaticFields.precodePreference));
    this.apiService.putData('SavePreferences', pref).subscribe(res => {    
      let params = new HttpParams();
      params = params.append('type', 'PreCode');
      params = params.append('appUserId', StaticFields.appUserId);
      this.apiService.getData('GetPreferences', params, false).subscribe((res: any) => {
        StaticFields.precodePreference = res;
        this.setScreenData();
      });     
    });     
  }

  addGeAssessments() {
    this.ref = this.dialogService.open(GeassessmentmodalComponent, { 
        data : {crops : this.crops, selectedCrop :this.selectedCrop, selectedAssessmentsList :this.geAssessmentsList },
        header: 'Search Germplasm Assessments',
        width: '95%',
        height: '90vh',
        styleClass: 'geModal',
        appendTo: 'body',
        closable : false
    });

    this.ref.onClose.subscribe((result : any) => {
      if (result) {
        const newAssessmentMembers = result.assessmentMembers.map((member : any) => {
          const { description: traitDescription, ...rest } = member;
          return { traitDescription, ...rest }
        });
        newAssessmentMembers.forEach((ele : any) => ele.selected = true);
        this.geAssessmentsList = [...newAssessmentMembers];
        this.geAssessmentsList = this.geAssessmentsList.filter(m => m.selected);
        this.savePreferences();
      }
    });
  }

  showPStageDialog() {
    this.showPStageModal = true;
    this.pStageDataCopy = JSON.parse(JSON.stringify(this.pStageData));
  }

  savePStageData(saveStage: boolean) {
    this.pStageData =   this.pStageData.reduce((resArr, currentArr) => {
      let index = resArr.findIndex((ele : any) =>  JSON.stringify(currentArr.year.sort()) === JSON.stringify(ele.year.sort()) && JSON.stringify(currentArr.name.sort()) ===  JSON.stringify(ele.name.sort()) && currentArr.type === ele.type && currentArr.settingType === ele.settingType);
      let existingPrefIndex = this.pStageData.findIndex((ele : any) => ele.id != 0 && JSON.stringify(currentArr.year.sort()) === JSON.stringify(ele.year.sort()) && JSON.stringify(currentArr.name.sort()) ===  JSON.stringify(ele.name.sort()) && currentArr.type === ele.type && currentArr.settingType === ele.settingType);
      if (index == -1 && existingPrefIndex < 0) resArr.push(currentArr)
      else if(index == -1 && existingPrefIndex > -1) resArr.push(this.pStageData[existingPrefIndex])
      return resArr
    }, [])
    if (!saveStage){
      this.showPStageModal = false;
      return;
    }
    if (this.pStageData.find(ele => (ele.type != "" && (ele.name.length === 0 || ele.year.length == 0)) || (ele.type == "" && (ele.name.length === 0 && ele.year.length == 0)))) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: `There are ${this.pStageData.length - this.validPstageData} row(s) with incomplete data found. Do you want to save remaining ${this.validPstageData} row(s).`,      
        accept: () => {
          this.pStageData = this.pStageData.filter(ele => ele.type !== "" && (ele.name.length > 0 && ele.year.length > 0));
          this.pStageData.forEach((ele : any) => ele.selected = this.pStagesList.find((e: any) => e.id == ele.id) ? this.pStagesList.find((e: any) => e.id == ele.id).selected : true);
          this.pStagesList = JSON.parse(JSON.stringify(this.pStageData));
          this.pStagesList.forEach((ele : any) => {ele.name = ele.name.join(","); ele.year =ele.year.join(",");});
          this.showPStageModal = false;
          this.savePreferences();
        }
      });
    } else {
      this.showPStageModal = false;
      this.pStageData.forEach((ele : any) => ele.selected = this.pStagesList.find((e: any) => e.id == ele.id) ? this.pStagesList.find((e: any) => e.id == ele.id).selected : true);     
      this.pStagesList = JSON.parse(JSON.stringify(this.pStageData))
      this.pStagesList.forEach((ele : any) => {ele.name = ele.name.join(","); ele.year =ele.year.join(",");});
      this.savePreferences();
    }
  }

  saveTags() {
    this.showTagModal = false;
    this.savePreferences();
  }

  addPStageRow() {
    const object : any = {'id' : this.pStageCounter,'type':"",'name':[],'year': [], crop : (this.selectedCrop ? this.selectedCrop.Name : undefined),selected : false};
    this.pStageCounter++;
    this.pStageData = [object,...this.pStageData];
  }

  deletePStageRow() {
    const removeRows = this.pStageGridApi.getSelectedRows();
    this.pStageData = this.pStageData.filter(ele => removeRows.indexOf(ele) == -1);
    this.pStageCounter - removeRows.length;
  } 

  onPStageGridReady($event: GridReadyEvent<any>) {
    this.pStageGridApi = $event.api;
  }

  onTagGridReady($event: GridReadyEvent<any>) {
    this.tagGridApi = $event.api;
    this.tagGridApi.setFilterModel({
      isActive: {
        filterType: "set",
        values: ['true']
      }
    });
  }

  changeHeaderColor(event : any, type: string){
    const index = this.colorOptions.findIndex((ele : any) => ele.type == type);
    this.colorOptions[index].color = event.value;
  }

  addPrgColor() {
    if (this.prgRgnEZColors.length === 100) {
      this.customMessageService.showMessage({severity: 'warn', summary:`Not Allowed` , detail: 'Maximum 100 Programs/Regions/Ezs can be added.'});
      return;
    }
    if (this.prgRgnEZColors.findIndex((p: any) => p.type === `${this.selType.name}:${this.selPrgRgnEZ.Code}`) === -1) {
      this.prgRgnEZColors.push({ type: `${this.selType.name}:${this.selPrgRgnEZ.Code.toUpperCase()}`, color: this.prgRgnEZColor, isProgram: true});
      this.selPrgRgnEZ = null;
    } else
      this.customMessageService.showMessage({severity: 'warn', summary:`Not Allowed` , detail: `${this.selType.name} ${this.selPrgRgnEZ.Code} is already present.`});
  }

  removePrgColor() {
    this.prgRgnEZColors = this.prgRgnEZColors.filter((ele: any) => !this.selPrgRgnEZColors.find((item : any) => item.type.toUpperCase() === ele.type.toUpperCase()));
    this.selPrgRgnEZColors.splice(0);
  }

  closePrgModel() {
    this.existingPrgRgnEZColors = JSON.parse(JSON.stringify(this.prgRgnEZColors));
    this.savePreferences();
    this.showProgramColorModel = false;
  }

  showPrgColorModal() {
    this.prgRgnEZColor = this.selPrgRgnEZ = null;
    this.prgRgnEZColors.splice(0);
    this.selPrgRgnEZColors.splice(0);
    this.prgRgnEZColors = JSON.parse(JSON.stringify(this.existingPrgRgnEZColors));
    this.showProgramColorModel = true;
  }

  changeType() {
    if (this.selType.name === "Program") {
      this.prgRgnEZNames = this.programs.map((d: any) => { return {Code: d.code, desc: d.Description};});
    } else if (this.selType.name === "Region") {
      this.prgRgnEZNames = this.regions.map((d: any) => { return {Code: d.Code, desc: d.Description};});
    } else if (this.selType.name === "EZ") {
      this.prgRgnEZNames = this.ezs.map((d: any) => { return {Code: d.code, desc: d.description};});
    } else if (this.prgRgnEZNames.length > 0){
      this.prgRgnEZNames.splice(0);
    }
  }

  onLevelSearch(word: string, item: { code: string, desc: string }): boolean {
    return item.code.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }

  onNGSearch(word: string, item: string): boolean {
    return item.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }

  addToTagList() {
    if (this.tag.length > 0) {
      let tags = this.tag.split(';');
      if (tags.length === 1)
        tags = tags[0].split(',');
      tags.forEach(tag => { 
        if (this.tags.findIndex((t: any) => t.tag.toUpperCase() === tag.trim().toUpperCase()) === -1)
          this.tags = [...this.tags, {tag: tag.trim(), isActive: true, group: ''}];
      });
      this.tag = "";
    }
  }

  removeSelectedTags() {
    const selRows = this.tagGridApi.getSelectedRows();
    const existingTags: string[] = [];
    selRows.forEach((t: any) => {
      if (this.tagsInUse.includes(t.tag.toLowerCase()))
        existingTags.push(t.tag);
    });
    if (existingTags.length > 0) {
      const msgText = existingTags.length === 1 ? `Tag ${existingTags[0]} is` : `Tags ${existingTags.join()} are`;
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Allowed', detail: `${msgText} mapped and can't be removed. Mark them inactive instead.` });
      return;
    }
    this.tags = this.tags.filter((t: any) => !selRows.includes(t));

      // this.confirmationService.confirm({
      //   header: 'Confirmation',
      //   icon: 'pi pi-exclamation-triangle',
      //   message: `${msgText} associated to one or more GE records and will delete these tag associations and remove data permanently. Are you sure you want to delete?`,      
      //   accept: () => {
      //     this.tags = this.tags.filter((t: any) => !selRows.includes(t));
      //   }
      // });
    // } else
    //   this.tags = this.tags.filter((t: any) => !selRows.includes(t));
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.tags.map((t: any) => t.tag).join(';'));
    this.customMessageService.showMessage({'severity': 'info', summary: 'Copied', detail: 'Tags have been copied to clipboard.' });
  }

  mergeTags() {
    const selRows = this.tagGridApi.getSelectedRows();
    const postData = { tagToDelete: selRows[0].tag, targetTag: this.tagToMerge, appUserId: StaticFields.appUserId };
    this.apiService.putData('MergeTags', postData).subscribe((res: any) => {
      if (res) {
        const udpatedTags: any = [];
        this.tags.filter((t: any) => t.tag !== selRows[0].tag).forEach((t: any) => {
          udpatedTags.push(t);
        });
        this.tags = [...udpatedTags];
        if (StaticFields.precodePreference)
          StaticFields.precodePreference.tags = this.tags.map((t: any) => `${t.tag}:${t.isActive}:${t.group}`).join(';');
        this.tagToMerge = "";
        this.mergeOverlayVisible = false;
      }       
    }); 
  }

  getTagContextMenuItems(params: any) {
    let result = [
        {
          name: 'Fill Up',
          disabled: !(!isNaN(params.node.rowIndex) && Number(params.node.rowIndex) > 0) || params.column.colId.includes('tag'),
          action: function () { params.context.componentParent.fill(params, "up"); },
        },
        {
          name: 'Fill Down',
          disabled: !(!isNaN(params.node.id) && Number(params.node.rowIndex) <  Number(params.node.parent.allChildrenCount) - 1) || params.column.colId.includes('tag'),
          action: function () { params.context.componentParent.fill(params, "down"); }
        },
        // {
        //   name: 'Fill Selected',
        //   disabled: params.api.getSelectedRows().length === 0 || params.column.colId.includes('tag'),
        //   action: function () { params.context.componentParent.fill(params, "selected"); }
        // },
        'separator',
        'copy',
        'copyWithHeaders'        
      ]
    return result;
  }

  fill(params: any, fillType: string) {
    if (fillType === "down" || fillType === "up") {
      let idx = params.node.rowIndex;
      params.api.forEachNodeAfterFilterAndSort((rowNode: any) => {
        if (fillType === "up" ? idx > rowNode.childIndex : idx < rowNode.childIndex) {
          rowNode.data[params.column.colId] = params.value;
        }
      });
    } else if (fillType === "selected") {
      params.api.getSelectedRows().forEach((rowNode: any) => {
        rowNode[params.column.colId] = params.value;
      });
    }
    params.api.refreshCells(params);
  }

  toggleActiveTags(args: any) {
    if (this.showInactiveTags) 
      this.tagGridApi.destroyFilter('isActive');
    else
      this.tagGridApi.setFilterModel({
        isActive: {
          filterType: "set",
          values: ['true']
        }
      });
  }
}
